import React, { Component } from 'react';
import { Form, Icon, Input, Button, Checkbox, Row, Col, Select, Tabs  } from 'antd';
import history from '../../helpers/history'

import CodeRegExp from './LoginCountrys';

import './flags.css';

const { TabPane } = Tabs;
const { Option } = Select;

var languageMessages = window.appLocale.messages;

const USERNAME = 'USERNAME';
const CAPTCHA = 'CAPTCHA';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const VerificationCodeLoginForm = Form.create({ name: 'verification_code_login_form' })(
    class extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                phone: '',
                captcha: '',
            };
        }

        componentDidMount() {
            //this.props.form.validateFields(['phone', 'captcha'], { first: true }, (err, values) => {
            //});
        }

        handlePhoneChange = e => {
            this.setState({ phone: e.target.value }, () => {
                this.props.handleChange();
            });
        }

        handleCaptchaChange = e => {
            this.setState({ captcha: e.target.value }, () => {
                this.props.handleChange();
            });
        }

        render() {
            const { isChangePrefixForCaptcha, prefix, phoneRegExp, handlePrefixSelector, username, isGetCaptcha, captchaWaiting, getCaptcha, count, logining, handleSubmit, form } = this.props;
            const { getFieldDecorator, getFieldsError } = form;
            let { phone, captcha } = this.state;

            if (phone === '') phone = username;

            var tmpPhoneRegExp = phoneRegExp;
            var tmpPrefix = prefix;

            if (isChangePrefixForCaptcha) {
                var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
                if (!regex.test(phone)) {
                    if (phone !== undefined && phone !== '') {
                        let users = phone.split('-');
                        if (users.length > 1) {
                            phone = users[1];
                        }
                    }
                }
                
                var options = [];
                for (var ii in CodeRegExp) {
                    var content = '';
                    if (CodeRegExp[ii].code == 'Email') {
                        var title = <Icon type="mail" />;
                        content = <span>{title} {CodeRegExp[ii].code}</span>
                    } else {
                        var className = 'flag flag-' + CodeRegExp[ii].des.toLowerCase();
                        var title = <span className={className}></span>;
                        content = <span>{title} {' +' + CodeRegExp[ii].code}</span>;
                    }

                    options.push(<Option key={ii} value={CodeRegExp[ii].des} label={content}>{content}</Option>);
                }
            } else {
                let prefixCode = '0';
                var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
                if (regex.test(phone)) {
                    prefixCode = 'Email';
                } else {
                    if (phone !== undefined && phone !== '') {
                        let users = phone.split('-');
                        if (users.length > 1) {
                            prefixCode = users[0];
                            phone = users[1];
                        }
                    }
                }
                
                var isFlag = false;
                var options = [];
                for (var ii in CodeRegExp) {
                    if (prefixCode === CodeRegExp[ii].code) {
                        if (!isFlag) {
                            tmpPrefix = CodeRegExp[ii].des;
                            tmpPhoneRegExp = CodeRegExp[ii].pattern;
                            isFlag = true;
                        }
                    }

                    var content = '';
                    if (CodeRegExp[ii].code == 'Email') {
                        var title = <Icon type="mail" />;
                        content = <span>{title} {CodeRegExp[ii].code}</span>
                    } else {
                        var className = 'flag flag-' + CodeRegExp[ii].des.toLowerCase();
                        var title = <span className={className}></span>;
                        content = <span>{title} {' +' + CodeRegExp[ii].code}</span>;
                    }

                    options.push(<Option key={ii} value={CodeRegExp[ii].des} label={content}>{content}</Option>);
                }
            }

            const prefixSelector = getFieldDecorator('prefix', { initialValue: tmpPrefix })(
                <Select style={{ width: 120 }}
                    optionLabelProp='label'
                    dropdownMatchSelectWidth={false}
                    dropdownClassName='common-login-prefix'
                    dropdownStyle={{ zIndex: 1005, minWidth: 100 }}
                    onChange={handlePrefixSelector}>
                    {options}
                </Select>,
            );

            let isDisabled = phone === '' || captcha === '';
            if (!isDisabled) {
                isDisabled = logining ? logining : (hasErrors(getFieldsError()));
            }

            return (
                <Form onSubmit={handleSubmit} className="login-form">
                    <Form.Item>
                        {getFieldDecorator('phone', {
                            initialValue: phone,
                            rules: [
                                { required: true, message: languageMessages['phone number and email address'] },
                                { pattern: tmpPhoneRegExp, message: languageMessages['format.failed'] }
                            ],
                        })(<Input addonBefore={prefixSelector} style={{ width: '100%' }} placeholder={languageMessages['phone number and email address']} onChange={this.handlePhoneChange} autoComplete={'new-phone'} />)}
                    </Form.Item>
                    <Form.Item>
                        <Row gutter={8}>
                            <Col span={12}>
                                {getFieldDecorator('captcha', {
                                    initialValue: captcha,
                                    rules: [{ required: true, message: languageMessages['please.input.captcha'] }],
                                })(<Input placeholder={languageMessages['Verification code']} onChange={this.handleCaptchaChange} autoComplete={'new-captcha'} />)}
                            </Col>
                            <Col span={12}>
                                {isGetCaptcha ? (<Button loading={captchaWaiting} onClick={getCaptcha}>{languageMessages['intl.register.getCaptcha']}</Button>) : (<Button disabled onClick={getCaptcha}>{count}s</Button>)}
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('remember', { valuePropName: 'checked', initialValue: true, })(<Checkbox>{languageMessages['intl.login.rememberMe']}</Checkbox>)}
                        <Button size='small' htmlType="submit" className="login-form-button" loading={logining} disabled={isDisabled}>
                            {logining ? languageMessages['intl.logining'] : languageMessages['intl.login']}
                        </Button>
                    </Form.Item>
                </Form>
            );
        }
    },
);

const UserPasswordLoginForm = Form.create({ name: 'user_password_login_form' })(
    class extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                phone: '',
                loginPassword: '',
            };
        }

        componentDidMount() {
            //this.props.form.validateFields(['phone', 'password'], { first: true }, (err, values) => {
            //});
        }

        handlePhoneChange = e => {
            this.setState({ phone: e.target.value }, () => {
                this.props.handleChange();
            });
        }

        handlePasswordChange = e => {
            this.setState({ loginPassword: e.target.value }, () => {
                this.props.handleChange();
            });
        }

        render() {
            const { isChangePrefixForPassword, prefix, phoneRegExp, handlePrefixSelector, username, password, logining, handleSubmit, form } = this.props;
            const { getFieldDecorator, getFieldsError } = form;
            let { phone, loginPassword } = this.state;

            if (phone === '') phone = username;
            if (loginPassword === '') loginPassword = password;

            var tmpPhoneRegExp = phoneRegExp;
            var tmpPrefix = prefix;

            if (isChangePrefixForPassword) {
                var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
                if (!regex.test(phone)) {
                    if (phone !== undefined && phone !== '') {
                        let users = phone.split('-');
                        if (users.length > 1) {
                            phone = users[1];
                        }
                    }
                }

                var options = [];
                for (var ii in CodeRegExp) {
                    var content = '';
                    if (CodeRegExp[ii].code == 'Email') {
                        var title = <Icon type="mail" />;
                        content = <span>{title} {CodeRegExp[ii].code}</span>
                    } else {
                        var className = 'flag flag-' + CodeRegExp[ii].des.toLowerCase();
                        var title = <span className={className}></span>;
                        content = <span>{title} {' +' + CodeRegExp[ii].code}</span>;
                    }

                    options.push(<Option key={ii} value={CodeRegExp[ii].des} label={content}>{content}</Option>);
                }
            } else {
                let prefixCode = '0';
                var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
                if (regex.test(phone)) {
                    prefixCode = 'Email';
                } else {
                    if (phone !== undefined && phone !== '') {
                        let users = phone.split('-');
                        if (users.length > 1) {
                            prefixCode = users[0];
                            phone = users[1];
                        }
                    }
                }

                var isFlag = false;
                var options = [];
                for (var ii in CodeRegExp) {
                    if (prefixCode === CodeRegExp[ii].code) {
                        if (!isFlag) {
                            tmpPrefix = CodeRegExp[ii].des;
                            tmpPhoneRegExp = CodeRegExp[ii].pattern;
                            isFlag = true;
                        }
                    }

                    var content = '';
                    if (CodeRegExp[ii].code == 'Email') {
                        var title = <Icon type="mail" />;
                        content = <span>{title} {CodeRegExp[ii].code}</span>
                    } else {
                        var className = 'flag flag-' + CodeRegExp[ii].des.toLowerCase();
                        var title = <span className={className}></span>;
                        content = <span>{title} {' +' + CodeRegExp[ii].code}</span>;
                    }

                    options.push(<Option key={ii} value={CodeRegExp[ii].des} label={content}>{content}</Option>);
                }
            }

            const prefixSelector = getFieldDecorator('prefix', { initialValue: tmpPrefix })(
                <Select style={{ width: 120 }}
                    optionLabelProp='label'
                    dropdownMatchSelectWidth={false}
                    dropdownClassName='common-login-prefix'
                    dropdownStyle={{ zIndex: 1005, minWidth: 100 }}
                    onChange={handlePrefixSelector}>
                    {options}
                </Select>,
            );

            let isDisabled = phone === '' || loginPassword === '';
            if (!isDisabled) {
                isDisabled = logining ? logining : (hasErrors(getFieldsError()));
            }

            return (
                <Form onSubmit={handleSubmit} className="login-form">
                    <Form.Item>
                        {getFieldDecorator('phone', {
                            initialValue: phone,
                            rules: [
                                { required: true, message: languageMessages['phone number and email address'] },
                                { pattern: tmpPhoneRegExp, message: languageMessages['format.failed'] }
                            ],
                        })(<Input addonBefore={prefixSelector} style={{ width: '100%' }} placeholder={languageMessages['phone number and email address']} onChange={this.handlePhoneChange} autoComplete={'new-phone'} />)}

                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('password', {
                            initialValue: loginPassword,
                            rules: [
                                { required: true, message: languageMessages['please.input.password'] }
                            ],
                        })(<Input.Password prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={languageMessages['account.password']} onChange={this.handlePasswordChange} autoComplete={'new-password'} />)}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('remember', { valuePropName: 'checked', initialValue: true, })(<Checkbox>{languageMessages['intl.login.rememberMe']}</Checkbox>)}
                        <Button size='small' htmlType="submit" className="login-form-button" loading={logining} disabled={isDisabled}>
                            {logining ? languageMessages['intl.logining'] : languageMessages['intl.login']}
                        </Button>
                    </Form.Item>
                </Form>
            );
        }
    },
);

class LoginForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loginMode: USERNAME,
            phoneRegExp: '',
            //phonePlaceholder: '',

            prefix: window.webType,//'CN',

            isChangePrefixForPassword: false,
            isChangePrefixForCaptcha: false,

            captchaWaiting: false,
        }
    }

    componentDidMount() {
        //this.userPasswordFormRef.props.form.resetFields();

        var tmpCodeRegExp = CodeRegExp.filter((e) => { return e.des === this.state.prefix });
        if (tmpCodeRegExp.length > 0) {
            //var phonePlaceholder = languageMessages['phone.china.only'];
            //if (window.webType !== 'CN') {
            //    phonePlaceholder = languageMessages['phone'];
            //}

            var phoneRegExp = tmpCodeRegExp[0].pattern;
            this.setState({
                phoneRegExp,
                //phonePlaceholder
            });
        }
    }

    componentWillReceiveProps(props) {
        var { status } = props;

        switch (status) {
            case 'Get_Captcha':
                this.setState({ captchaWaiting: false });
                break;
            case 'Get_Email_Captcha':
                this.setState({ captchaWaiting: false });
                break;
            default:
                break;
        }
    }

    onSwitchLoginMode = value => {
        this.setState({ loginMode: value }, () => {
            //switch (value) {
            //    case 'USERNAME':
            //        this.userPasswordFormRef.props.form.resetFields();
            //        break;
            //    case 'CAPTCHA':
            //        this.verificationCodeFormRef.props.form.resetFields();
            //        break;
            //    default:
            //        break;
            //}
        });
    }

    getCaptcha = e => {
        e.preventDefault();
        let { isGetCaptcha } = this.props;
        
        this.verificationCodeFormRef.props.form.validateFields(['phone'], (err, values) => {
            if (!err) {
                if (isGetCaptcha) {
                    var prefix = this.verificationCodeFormRef.props.form.getFieldValue('prefix');
                    this.setState({ captchaWaiting: true }, () => {
                        if ('Email' == prefix) {
                            this.props.dispatch({ type: "action_email_captcha", payload: { Mode: 'login', Email: values.phone } });
                        } else {
                            //发送手机验证码
                            this.props.dispatch({ type: "action_login_captcha", payload: { UserName: values.phone, Prefix: prefix } });
                        }
                    });
                }
            }
        });
    }

    handleVerificationCodeSubmit = e => {
        e.preventDefault();
        this.verificationCodeFormRef.props.form.validateFields((err, values) => {
            if (!err) {
                var mode = 'phone';
                if ('Email' == values.prefix) {
                    mode = 'email';
                }

                var requestData = {
                    Mode: mode,
                    Prefix: values.prefix,
                    UserName: values.phone,
                    Captcha: values.captcha,
                    RememberMe: values.remember
                };

                window._hmt && window._hmt.push(['_trackEvent', 'Login', 'Login', requestData.UserName]);

                // login
                this.props.dispatch({ type: "action_login", payload: requestData });
            }
        });
    }

    handleUserPasswordSubmit = e => {
        e.preventDefault();
        this.userPasswordFormRef.props.form.validateFields((err, values) => {
            if (!err) {
                var mode = 'phone';
                if ('Email' == values.prefix) {
                    mode = 'email';
                }

                var requestData = {
                    Mode: mode,
                    Prefix: values.prefix,
                    UserName: values.phone,
                    Password: values.password,
                    RememberMe: values.remember
                };

                window._hmt && window._hmt.push(['_trackEvent', 'Login', 'Login', requestData.UserName]);

                // login
                this.props.dispatch({ type: "action_login", payload: requestData });
            }
        });
    };

    handleUserPasswordPrefixSelector = value => {
        var tmpCodeRegExp = CodeRegExp.filter((e) => { return e.des === value });
        if (tmpCodeRegExp.length > 0) {
            var phoneRegExp = tmpCodeRegExp[0].pattern;
            this.setState({
                phoneRegExp,
                prefix: value,
                isChangePrefixForPassword: true,
            }, () => {
                //this.userPasswordFormRef.props.form.validateFields();
                this.userPasswordFormRef.props.form.validateFields(['phone']);

            });
        }

        this.props.handleChange({ error: '' });
    }

    handleVerificationCodePrefixSelector = value => {
        var tmpCodeRegExp = CodeRegExp.filter((e) => { return e.des === value });
        if (tmpCodeRegExp.length > 0) {
            var phoneRegExp = tmpCodeRegExp[0].pattern;
            this.setState({
                phoneRegExp,
                prefix: value,
                isChangePrefixForCaptcha: true,
            }, () => {
                //this.verificationCodeFormRef.props.form.validateFields();
                this.verificationCodeFormRef.props.form.validateFields(['phone']);
            });
        }

        this.props.handleChange({ error: '' });
    }

    handleChange = () => {
        this.props.handleChange({ error: '' });
    }

    SetUserPasswordFormRef = formRef => {
        this.userPasswordFormRef = formRef;
    }

    SetVerificationCodeFormRef = formRef => {
        this.verificationCodeFormRef = formRef;
    }

    render() {
        let { loginMode, prefix, phoneRegExp, isChangePrefixForPassword, isChangePrefixForCaptcha, captchaWaiting } = this.state;

        return (<div className='login-register-card-class'>
            <Tabs size="small" defaultActiveKey={loginMode} onChange={this.onSwitchLoginMode}>
                <TabPane tab={languageMessages['intl.login.userNameLogin']} key={USERNAME}>
                    <UserPasswordLoginForm
                        wrappedComponentRef={this.SetUserPasswordFormRef}
                        isChangePrefixForPassword={isChangePrefixForPassword}
                        prefix={prefix}
                        phoneRegExp={phoneRegExp}
                        handlePrefixSelector={this.handleUserPasswordPrefixSelector}
                        username={this.props.username}
                        password={this.props.password}
                        handleChange={this.handleChange}
                        logining={this.props.logining}
                        handleSubmit={this.handleUserPasswordSubmit}
                    />                                                                                                               
                </TabPane>
                <TabPane tab={languageMessages['intl.login.verificationCodeLogin']} key={CAPTCHA}>
                    <VerificationCodeLoginForm
                        wrappedComponentRef={this.SetVerificationCodeFormRef}
                        isChangePrefixForCaptcha={isChangePrefixForCaptcha}
                        prefix={prefix}
                        phoneRegExp={phoneRegExp}
                        handlePrefixSelector={this.handleVerificationCodePrefixSelector}
                        username={this.props.username}
                        isGetCaptcha={this.props.isGetCaptcha}
                        captchaWaiting={captchaWaiting}
                        getCaptcha={this.getCaptcha}
                        count={this.props.count}
                        handleChange={this.handleChange}
                        logining={this.props.logining}
                        handleSubmit={this.handleVerificationCodeSubmit}
                    />
                
                </TabPane>
            </Tabs>
        </div>
        )
    }
}

export { LoginForm as default }